/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShoppingDiagnosticsFormConfiguration
 */
export interface ShoppingDiagnosticsFormConfiguration {
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    readonly fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    readonly cabinClasses?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    readonly channels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    readonly salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof ShoppingDiagnosticsFormConfiguration
     */
    defaultSalesJourney?: CodeAndLabel;
}

export function ShoppingDiagnosticsFormConfigurationFromJSON(json: any): ShoppingDiagnosticsFormConfiguration {
    return ShoppingDiagnosticsFormConfigurationFromJSONTyped(json, false);
}

export function ShoppingDiagnosticsFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoppingDiagnosticsFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CodeAndLabelFromJSON)),
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'defaultSalesJourney': !exists(json, 'defaultSalesJourney') ? undefined : CodeAndLabelFromJSON(json['defaultSalesJourney']),
    };
}

export function ShoppingDiagnosticsFormConfigurationToJSON(value?: ShoppingDiagnosticsFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'defaultSalesJourney': CodeAndLabelToJSON(value.defaultSalesJourney),
    };
}


